import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { CondicoesMoradia } from 'src/app/core/condicoes-moradia';
import { DataUtilService } from 'src/app/services/commons/data-util.service';
import { EnderecoService } from 'src/app/services/endereco/endereco.service';
import { Familiares } from '../../../core/familiares';
import { GrausParentesco } from '../../../core/graus-parentesco';
import { PessoaFisica } from '../../../core/pessoa-fisica';
import { CondicoesMoradiaService } from '../../../services/condicoes-moradia/condicoes-moradia.service';
import { GrausParentescoService } from '../../../services/graus-parentesco/graus-parentesco.service';
import { PessoaFisicaService } from '../../../services/pessoa-fisica/pessoa-fisica.service';
import { ConfirmDialogComponent } from '../../common/confirm-dialog/confirm-dialog.component';

@Component({
  selector:  'dados-pessoais-aluno',
  templateUrl:  './dados-pessoais-aluno.component.html',
  styleUrls:  ['./dados-pessoais-aluno.component.css'],
  viewProviders:  [{ provide:  ControlContainer, useExisting:  NgForm }]
})
export class DadosPessoaisAlunoComponent implements OnInit {

  @Input() pessoaFisica: PessoaFisica;
  @Input() familiar: Familiares;
  @Output() pesquisaPessoaFisica: EventEmitter<PessoaFisica> = new EventEmitter();

  public maskCep     = [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/];
  public maskPhone   = ['(', /[1-9]/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  public maskCelular = ['(', /[1-9]/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  public mascaraCpf   = [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/,];




  sim_nao: any[] = [
    {tipo: 'Sim', flag: 'S'},
    {tipo: 'Não', flag: 'N'}
  ];

  condicoesMoradia: CondicoesMoradia[];

  tipoEscola: any[] = [
    {id:  'P', tipo:  'PÚBLICO'},
    {id:  'R', tipo:  'PRIVADO'},
  ];

  nivelEscolaridade: any[] =[
    { id: 'C' , tipo: 'COMPLETO'},
    { id: 'I' , tipo: 'CURSANDO'},
  ]


  constructor(
    private grausParentescoService: GrausParentescoService,
    private condicoesMoradiaService: CondicoesMoradiaService,
    private enderecoService: EnderecoService,
    private pessoaFisicaService: PessoaFisicaService,
    private dataUtilService: DataUtilService,
    private dialog: MatDialog,
  ) { }

  ngOnInit() {
    this.familiar = new Familiares();
    this.familiar.grauParentesco = new GrausParentesco();

    this.condicoesMoradiaService.getAll().subscribe((condicoesMoradia: CondicoesMoradia[])=> {
      this.condicoesMoradia = condicoesMoradia;
    });


  }

  fileChangeEvent(event:  any):  void {
    this.pessoaFisica.foto = event.target.files[0];
    this.pessoaFisica.isFotoChanged = true;
    this.readThis(event.target);
  }

  getBackground(){
    if(this.pessoaFisica && this.pessoaFisica.urlFoto){
      return `url(${this.pessoaFisica.urlFoto})`
    }
  }

  readThis(inputValue:  any):  void {
    var file: File = inputValue.files[0];
    var myReader: FileReader = new FileReader();

    myReader.onloadend = (e) => {
      this.pessoaFisica.urlFoto = myReader.result;
    }
    myReader.readAsDataURL(file);
  }

  onMascaraDataInput(event) {
    return this.dataUtilService.onMascaraDataInput(event);
  }

  consultaPessoaFisica() {
    if(this.pessoaFisica.cpf) {
      const cpf = this.pessoaFisica.cpf.replace(/[^0-9]/g,'');
      if(cpf.length === 11) {
        this.pessoaFisicaService.getByCpf(this.pessoaFisica.cpf).subscribe((pessoaFisica: PessoaFisica) => {
          if(pessoaFisica && pessoaFisica.id) {
            this.chamaCaixaDialogo(pessoaFisica);
          }
        });
      } else {
        this.pessoaFisica.id = null;
      }
    }
  }

  chamaCaixaDialogo(pessoaFisica: PessoaFisica) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      pergunta: `Existe uma pessoa cadastrada com o CPF informado. Deseja reutilizar seus dados?`,
      textoConfirma: 'SIM',
      textoCancela: 'NÃO'
    };

    const dialogRef = this.dialog.open(ConfirmDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(confirma => {
      if (confirma) {
        this.pesquisaPessoaFisica.emit(pessoaFisica);
      } else {
        this.pessoaFisica.cpf = null;
        dialogRef.close();
      }
    }
    );
  }

  get idadeFormatada(): string {
    if (!this.pessoaFisica?.dataNascimento) return '';

    const hoje = new Date();
    const nascimento = new Date(this.pessoaFisica.dataNascimento);

    let anos = hoje.getFullYear() - nascimento.getFullYear();
    let meses = hoje.getMonth() - nascimento.getMonth();

    if (meses < 0 || (meses === 0 && hoje.getDate() < nascimento.getDate())) {
      anos--;
      meses += 12;
    }

    const parteAnos = anos > 0 ? `${anos} ${anos === 1 ? 'ano' : 'anos'}` : '';
    const parteMeses = meses > 0 ? `${meses} ${meses === 1 ? 'mês' : 'meses'}` : '';

    if (parteAnos && parteMeses) return `${parteAnos} e ${parteMeses}`;
    return parteAnos || parteMeses || '0 mês';
  }

  onEstadoCivilChange(estadoCivil: any) {
    this.pessoaFisica.estadoCivil = estadoCivil?.tipo;
  }

  onTipoSangueChange(tipoSangue: any) {
    this.pessoaFisica.tipoSangue = tipoSangue?.tipo;
  }

  onUfChange(uf: any) {
    this.pessoaFisica.ufNascimento = uf?.nome;
  }

  onSexoChange(sexo: any) {
    this.pessoaFisica.sexo = sexo?.sigla;
  }

  onRacaChange(raca: any) {
    this.pessoaFisica.raca = raca?.tipo;
  }

  onDescricaoParentescoTelefoneResidencialChange(parentesco: any) {
    this.pessoaFisica.descricaoParentescoTelefoneResidencial = parentesco?.nome;
  }

  onDescricaoParentescoFoneRecadoChange(parentesco: any) {
    this.pessoaFisica.descricaoParentescoFoneRecado = parentesco?.nome;
  }

  onDescricaoParentescoCelularChange(parentesco: any) {
    this.pessoaFisica.descricaoParentescoCelular = parentesco?.nome;
  }

  onDescricaoParentescoCelular2Change(parentesco: any) {
    this.pessoaFisica.descricaoParentescoCelular2 = parentesco?.nome;
  }

  onDescricaoParentescoCelular3Change(parentesco: any) {
    this.pessoaFisica.descricaoParentescoCelular3 = parentesco?.nome;
  }

  onDescricaoParentescoEmailChange(parentesco: any) {
    this.pessoaFisica.descricaoParentescoEmail = parentesco?.nome;
  }

}
